import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';

function LoginCallback() {
    const navigate = useNavigate();

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const token = urlParams.get('token');
        
        console.log("Token:", token);

        if (token == null) {
            navigate('/', { replace: true });
            console.log("null");
        } else if (token === 'failed') {
            navigate('/', { replace: true });
            console.log("failed");
        } else {
            console.log("got it");
            navigate('/', { replace: true });
            localStorage.setItem('user_id', token);
        }
    }, [navigate]);

    return <div></div>;
}

export default LoginCallback;
